import Typography from "@mui/material/Typography";
import { FormattedMessage } from "react-intl";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary
} from "../base/accordion";
import { Divider } from "@mui/material";

const pStyle = {
  fontSize: "18px"
  // marginBottom: "16px",
};

export default function EbayGuide2(props) {
  return (
    <Accordion {...props}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon color="primary" />}
        aria-controls="panel1a-content"
      >
        <Typography sx={{ fontWeight: 500 }}>
          <FormattedMessage id="ebay.guide2.title" />
        </Typography>
      </AccordionSummary>
      <Divider />
      <AccordionDetails>
        {" "}
        <Typography
          className="text"
          component="p"
          sx={{
            fontSize: "20px",
            marginBottom: "16px"
          }}
        >
          <FormattedMessage
            id="ebay.guide2.step1"
            values={{
              b: (...chunks) => {
                return <b style={{ fontWeight: "500" }}>{chunks}</b>;
              },
              br: <br />
            }}
          />
        </Typography>
      </AccordionDetails>
    </Accordion>
  );
}
